import { Form } from '@ant-design/compatible'

import ManageProviderForm from './ManageProviderForm'

export default Form.create({
  name: 'providerForm',
})(ManageProviderForm)
